module.exports = __webpack_public_path__ + "img/36.7b87f4c3.jpg";